import {FocusDirective} from "./focus.directive";
import {NgModule} from "@angular/core";

@NgModule({
	declarations: [
		FocusDirective
	],
	exports: [
		FocusDirective
	],
	imports: [

	],
})
export class FocusModule {
}
